<template>
    <div    class="flex justify-around">
        <div    class="w-3/5 grid-cols-12">
            <!-- Access is enforced by UITestsLinksPageController, so every test is shown. -->
            <ul class="mt-3 grid grid-cols-1 gap-5 sm:gap-5 md:grid-cols-2">
                <li     v-for="link in links"
                        :key="link.link"
                        class="col-span-1">
                    <setting-page-link-with-icon    :href="link.link"
                                                    :icon="link.icon"
                                                    :text="link.text"
                    ></setting-page-link-with-icon>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
import SettingPageLinkWithIcon from "@/components/SonicuSidebar/SettingPageLinkWithIcon.vue";

export default {
    name: "UITestsLinksPage",
    components: {SettingPageLinkWithIcon},
    data() {
        return {
            links: [
                {
                    text: 'Select 2',
                    link: '/scripts/ui-tests/select2',
                    icon: 'icon-clipboard-check',
                },
                {
                    text: 'Feature Level / Permissions',
                    link: '/scripts/ui-tests/feature-level-permission',
                    icon: 'icon-clipboard-user',
                },
                {
                    text: 'Date Range Picker',
                    link: '/scripts/ui-tests/date-range-picker',
                    icon: 'icon-calendar-full',
                },
                {
                    text: 'Point Select Tree',
                    link: '/scripts/ui-tests/point-select-tree',
                    icon: 'icon-share',
                },
                {
                    text: 'Report Components',
                    link: '/scripts/ui-tests/report-components',
                    icon: 'icon-grid',
                },
            ],
        }
    },
}
</script>
